import React from "react";
import { Markup } from "interweave";

const ClientMessages = ({ client }) => {
  const hasSlogan = Boolean(client?.slogan);
  const hasMarketingMessage = Boolean(client?.marketingMessage);

  return (
    <div className="gog-client-messages">
      {hasSlogan && (
        <div className="gog-client-slogan">
          <Markup content={client.slogan} />
        </div>
      )}

      {hasMarketingMessage ? (
        <div className="gog-marketing-message">
          <Markup content={client.marketingMessage} />
        </div>
      ) : (
        <div className="gog-empty-state">
          No marketing message is available for this merchant.
        </div>
      )}
    </div>
  );
};

export default ClientMessages;